export default "__VITE_ASSET__c059ed41__"